import { LTime } from '@app/components/date/LTime';
import { TopicCategoryChip } from '@app/modules/logger/screens/stream/features/live-topics/shared/topic-category-chip/TopicCategoryChip';
import { LiveTopic } from '../../live-topics-types';
import { toDateTimeStr } from '@mi-front/core';
import { DurationForRange, LocaleRelativeTime } from '@mi-front/ui';
import AssistantOutlinedIcon from '@mui/icons-material/AssistantOutlined';
import { Box, Typography } from '@mui/material';

/**
 * Displays the live topic category and timing metadata in the popup header.
 */
export function LiveTopicPopupHeader({ topic }: { topic: LiveTopic }) {
  return (
    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box sx={{ display: 'flex', color: 'text.disabled', '& svg': { fontSize: 18 } }}>
        <AssistantOutlinedIcon />
      </Box>
      {topic.category && (
        <>
          <TopicCategoryChip category={topic.category} />
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ '&::first-letter': { textTransform: 'uppercase' } }}
          >
            <LocaleRelativeTime value={topic.start_time} />
            {' · '}
            <LTime value={toDateTimeStr(new Date(topic.start_time))} hour12={false} showSeconds />
            {' · '}
            <DurationForRange from={topic.start_time} to={topic.end_time} />
          </Typography>
        </>
      )}
    </Box>
  );
}
